import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography, Box, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import logo from '../../assets/images/logo.svg';
import backgroundImage from '../../assets/images/background.png';

const MfaLayout = ({
  title, subtitle, subtitle2, children, hasError,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          margin: { xs: '0 12px', sm: '0 30px' },
          width: { xs: '100%', sm: '90%' },
          maxWidth: '900px',
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ alignSelf: 'center', width: isSmallScreen ? '240px' : undefined }}
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            border: '1px solid #D1D5DC',
            borderRadius: '12px',
            boxShadow: '0px 6px 26px #626B7D12',
            marginTop: '20px',
            paddingTop: '30px',
            paddingBottom: '30px',
            paddingLeft: { xs: '14px', sm: '40px' },
            paddingRight: { xs: '14px', sm: '40px' },
          }}
        >
          <Typography style={{ color: '#4D4D4D', fontSize: 21, fontWeight: 600 }}>
            {title}
          </Typography>

          <Typography
            sx={{
              color: hasError ? '#EA2027' : '#8F8F8F',
              fontSize: '14px',
              textAlign: { xs: 'center' },
              marginTop: '8px',
            }}
          >
            {subtitle}
          </Typography>

          {subtitle2 && (
            <Typography
              sx={{
                color: hasError ? '#EA2027' : '#8F8F8F',
                fontSize: '14px',
                textAlign: { xs: 'center' },
                marginTop: '3px',
                marginBottom: '8px',
              }}
            >
              {subtitle2}
            </Typography>
          )}

          {children}
        </Box>
      </Box>
    </Box>
  );
};

MfaLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  subtitle2: PropTypes.string,
  children: PropTypes.node.isRequired,
  hasError: PropTypes.bool,
};

MfaLayout.defaultProps = {
  subtitle2: null,
  hasError: false,
};

export default MfaLayout;
